exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2ba4fb08S-exan0LWLJEOP{height:100%}._3RxGsnFI0Tm6ujjtU4Woym{font-weight:700;margin-top:0}._2P25nuTTvxS9ypIPyKI4VA{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin:1.28571rem 0}._3Dk_FZ00vCFmRiQ2k9jPOL{-webkit-flex-basis:65%;-ms-flex-preferred-size:65%;flex-basis:65%}@media only screen and (min-width:800px){._3Dk_FZ00vCFmRiQ2k9jPOL{-webkit-flex-basis:40%;-ms-flex-preferred-size:40%;flex-basis:40%}}@media only screen and (min-width:800px){._2YNpvhAd4czFQZrr0WnKr_{margin-right:.71429rem}}._3emVLuWnX70OFJgTxvoyQE{font-weight:700}._2nl3zYfjIlSKEwfta5_n21{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"SkillScoreCard": "_2ba4fb08S-exan0LWLJEOP",
	"SkillScoreCard_heading": "_3RxGsnFI0Tm6ujjtU4Woym",
	"SkillScoreCard_progressWrapper": "_2P25nuTTvxS9ypIPyKI4VA",
	"SkillScoreCard_progressBar": "_3Dk_FZ00vCFmRiQ2k9jPOL",
	"SkillScoreCard_mistakesLink": "_2YNpvhAd4czFQZrr0WnKr_",
	"SkillScoreCard_scoreBand": "_3emVLuWnX70OFJgTxvoyQE",
	"SkillScoreCard_description": "_2nl3zYfjIlSKEwfta5_n21"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReport/StudentReportView/SkillScoreCard/style.postcss
// module id = 1497
// module chunks = 0